import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Box } from '@chakra-ui/react';
const VARIANT_COLOR = {
    success: '{colors.stateSuccess}',
    info: '{colors.textLink}',
    error: '{colors.stateError}',
    neutral: '{colors.textTertiary}'
};
const BadgeFC = ({ variant = 'neutral', color, children }) => {
    const badgeColor = color ?? VARIANT_COLOR[variant];
    return (_jsx(Box, { display: 'inline-flex', alignItems: 'center', px: '10px', py: '2px', borderRadius: 'full', fontSize: '14px', fontWeight: '500', color: badgeColor, bg: `color-mix(in srgb, ${badgeColor} 12%, transparent)`, children: children }));
};
export const Badge = memo(BadgeFC);
//# sourceMappingURL=Badge.js.map